import { Box, Typography, Paper, Grid2 as Grid, Alert, Chip } from "@mui/material";
import { PageHeader } from "@/components/PageHeader";
import { useQuery } from "@tanstack/react-query";
import { diagnosticsApi } from "@/api/diagnostics";
import { errorMessage } from "@/api/client";

function Tile({ label, value, alert }: { label: string; value: number | string; alert?: boolean }) {
  return (
    <Paper sx={{ p: 2, textAlign: "center", borderTop: alert ? "3px solid" : undefined, borderColor: "error.main" }}>
      <Typography variant="h4" fontWeight={600} color={alert ? "error.main" : undefined}>{value}</Typography>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
    </Paper>
  );
}

export function DiagnosticsLabDashboardPage() {
  const q = useQuery({ queryKey: ["dx-lab-dashboard"], queryFn: () => diagnosticsApi.labDashboard(), refetchInterval: 30000 });
  const d = q.data;
  return (
    <Box>
      <PageHeader breadcrumbs={["Diagnostics"]} title="Laboratory dashboard" />
      {q.isError && <Alert severity="error" sx={{ mb: 2 }}>{errorMessage(q.error)}</Alert>}
      {d && (
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, md: 3 }}><Tile label="Orders today" value={d.todayOrders} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><Tile label="Results today" value={d.todayResults} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><Tile label="Pending samples" value={d.pendingSamples} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><Tile label="Critical (pending ack)" value={d.criticalPending} alert={d.criticalPending > 0} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><Tile label="QC violations (30d)" value={d.qcViolations30d} alert={d.qcViolations30d > 0} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><Tile label="Rejection rate" value={`${d.rejectionRatePct}%`} alert={d.rejectionRatePct >= 5} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><Tile label="Avg TAT (min, 7d)" value={d.tatAvgMinutes} /></Grid>
          <Grid size={{ xs: 6, md: 3 }}><Tile label="P90 TAT (min, 7d)" value={d.tatP90Minutes} /></Grid>
        </Grid>
      )}
      <Chip size="small" variant="outlined" label="Auto-refreshes every 30s" sx={{ mt: 2 }} />
    </Box>
  );
}
